<template>
    <v-alert
            class="mt-5"
            style="margin-bottom: 40px"
            v-if="displayThanks && organism !== null"
    >
        <div class="d-flex justify-content-start">
            <div
                    class="logo"
                    v-if="logo !== null"
            >
                <v-img
                        height="100px"
                        max-width="300px"
                        position="center"
                        contain
                        :src="logo.doc_url"
                >
                </v-img>
            </div>

            <div>
                <h4>Merci pour votre réponse !</h4>
                <div v-if="organism !== null">{{ organism }} vous remercie d'avoir mis à jour vos informations.</div>
            </div>
        </div>
    </v-alert>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex"

export default {
    name: "FormThanks",
    props: ['organism', 'logo'],
    computed: {
        ...mapState("web_form", ['displayThanks'])
    }
}
</script>